import { Group } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import P2Regular from 'components/typography/P2Regular';
import { FaultRow } from 'components/tables/data/fault/types';

/**
 * Column for the fixed by name.
 */
export default function FixedByNameColumn({ data: { fixed } }: { data: FaultRow }) {
  if (!fixed?.fixedBy?.userId) return null;

  return (
    <Group spacing={8} noWrap>
      <IconUser stroke={1.5} size={24} />
      <P2Regular color="gray.8" lineClamp={3}>
        {fixed.fixedBy.fullName}
      </P2Regular>
    </Group>
  );
}
